<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-button tag="router-link" :to="{ name: 'CommunicationOverview' }" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column small-9">
                <h1>{{ record && record.name ? record.name : 'Communicatie aanpassen' }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form verticalpadding">
                    <div class="row" v-if="user && user.role == 'pit'">
                        <div class="column">
                            <b-field label="Organisatie (PIT)"
                                :message="getError(errors, 'organisation')"
                                :type="getType(errors, 'organisation', '')"
                            >
                                <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                    <option value="base">Alle organisaties - Basis</option>
                                    <option
                                        v-for="organisation in organisations"
                                        :value="organisation.id"
                                        :key="'organisatie_'+organisation.id"
                                    >(ID: {{ organisation.id }}) {{ organisation.name }}</option>
                                </b-select>
                            </b-field>
                            <br>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column" v-if="user.role == 'pit'">
                            <b-field label="Naam"
                                :message="getError(errors, 'name')"
                                :type="getType(errors, 'name', '')"
                            >
                                <b-input v-model="record.name" placeholder="Naam" maxlength="40"></b-input>
                            </b-field>
                        </div>

                        <div class="column">
                            <b-field :label="record.type == 'email' ? 'Titel (email onderwerp)' : 'Titel'"
                                :message="getError(errors, 'title')"
                                :type="getType(errors, 'title', '')"
                            >
                                <b-input v-model="record.title" placeholder="Titel" maxlength="78"></b-input>
                            </b-field>
                        </div>

                        <div class="column" v-if="user && user.role == 'pit'">
                            <b-field label="Hero (alleen door admins instelbaar) - grote tekst boven de content"
                                :message="getError(errors, 'hero')"
                                :type="getType(errors, 'hero', '')"
                            >
                                <b-input v-model="record.hero" placeholder="Grote tekst boven e-mail" maxlength="30"></b-input>
                            </b-field>
                        </div>

                        <div class="column">
                            <b-field label="Content"
                                :message="getError(errors, 'content')"
                                :type="getType(errors, 'content', '')"
                            >
                                <QuillEditor
                                    :theContent="record.content"
                                    @contentChanged="contentChanged"
                                    :toolbar="[
                                        ['bold', 'italic', 'underline', 'strike'],
                                        ['blockquote'],
                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                        [{ 'color': [] }],
                                    ]"
                                />
                            </b-field>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row" v-show="!hideSaving">
            <div class="column text-right">
                <div class="formfooter">
                    <!-- <b-button type="is-success" :loading="loading" @click="saveRecord">Opslaan</b-button> -->
                    <b-button type="is-dark" :loading="loading" @click="saveAndQuit">Opslaan en sluiten</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuillEditor from '../QuillEditor'
import toastMixin from '@/mixins/toastMixins'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'

export default {
    components: {
        QuillEditor
    },

    mixins: [toastMixin, formvalidationMixin],

    data() {
        return {
            loading: false,
            record: {},
            errors: {}
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hideSaving() {
            let hideSaving = false

            if(_.has(this.user.organisation_settings, 'strictroles') && this.user.organisation_settings.strictroles == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideSaving = true
            }

            return hideSaving
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        }
    },

    created () {
        this.fetchRecord()
    },

    methods: {
        fetchRecord() {
            this.loading = true

            axios.get('/api/communication/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if (_.isNull(response.data.organisation)) {
                    response.data.organisation = 'base' // Set as base.
                }

                this.record = response.data
            }).catch((error) => {
                console.error('[❌] Error while fetching communication', error)
                this.$buefy.toast.open({message: 'Geen toegang!', type: 'is-danger'})
                this.$router.push({name: 'CommunicationOverview'})
            }).then(() => {
                this.loading = false
            })
        },

        saveAndQuit(){
            this.loading = true

            this.save().then(() => {
                this.$router.push({name: 'CommunicationOverview'})
            }).catch((error) => {
                // ..
            }).finally(() => {
                this.loading = false
            })
        },

        saveRecord(){
            this.loading = true

            this.save().then((response) => {
                setTimeout(() => {
                    this.record = response
                    this.loading = false
                }, 500)
            })
        },

        save() {
            return new Promise((resolve, reject) => {
                axios.post('/api/communication/'+this.$route.params.id, this.record, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    this.showMessage('Succesvol opgeslagen!')

                    resolve(response.data)
                }).catch((error) => {
                    console.error('[❌] Error while saving communication:', error)

                    if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                        this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
                    } else {
                        this.errors = {...error.response.data.errors}
                        this.showError('Opslaan mislukt - Onvoldoende of onjuiste gegevens.')
                    }

                    this.loading = false
                    reject()
                })
            })
        },

        contentChanged(content){
            this.record.content = content
        }
    }
}
</script>

